import * as queryString from 'query-string';

const MFA_PATH = '/mfa';
const MFA_SETUP_PATH = '/mfa-setup';
const ONBOARDING_PATH = '/onboarding';

export const resolveMagicLinkRoute = (user, callbackUrl) => {
    const { mfaOptions, onboardingRequired, onboardingCompleted } = user ?? {};

    if (mfaOptions?.mfaRequired) {
        return {
            pathname: mfaOptions?.mfaEnabled ? MFA_PATH : MFA_SETUP_PATH,
            search: callbackUrl ? `?${queryString.stringify({ next: callbackUrl })}` : '',
        };
    }

    if (onboardingRequired && !onboardingCompleted) {
        return {
            pathname: ONBOARDING_PATH,
            search: callbackUrl ? `?${queryString.stringify({ return: callbackUrl })}` : '',
        };
    }

    return null;
};
